export function getDatalayerValue(key) {
    const datalayerHelper = createDatalayerHelper();
    if (!datalayerHelper) return undefined;
    return datalayerHelper.get(key);
}

function getDataLayer() {
    if (window.DATALAYER_RESTRUCTURING_ENABLED) {
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer;
    } else {
        window.newDataLayer = window.newDataLayer || [];
        return window.newDataLayer;
    }
}

function createDatalayerHelper() {
    const dataLayer = getDataLayer();
    if (!dataLayer|| !window.DataLayerHelper) {
        console.debug(`[SuchOCS] DatalayerHelper: dataLayer or DataLayerHelper not found!`);
        return undefined;
    };
    return new DataLayerHelper(dataLayer);
}
